module.exports = {
  siteMetadata: {
    title: "",
    url: "https://winpeforum.com",
    description:
      "Winpe is a pioneering platform founded in 2020, dedicated to creating a culture of growth and advancing gender diversity in private equity.",
    image: "https://winpeforum.com/assets/elements/WinPE_siteMeta_Image.png",
  },
  plugins: [
    `gatsby-plugin-sass`,
    {
      resolve: "gatsby-plugin-google-analytics",
      options: {
        trackingId: "UA-149383728-1",
      },
    },
  ],
};

// <!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=UA-149383728-1"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   gtag('js', new Date());

//   gtag('config', 'UA-149383728-1');
// </script>



// WEBPACK FOOTER //
// ./gatsby-config.js